import { createFileRoute } from '@tanstack/react-router';
import { LinkPage } from '@/features/link/link-page.js';

/**
 * The link page (tablet.md section 2.9): a top-level route outside `_app`,
 * opened from a platform's one-time link (`/link#<token>`) on the employee's
 * own screen. It needs no employee session; the token authenticates it.
 */
export const Route = createFileRoute('/link')({
  component: LinkPage,
});
